export const ERROR_CODE_INVALID_CSRF: string = "middleware/invalid-csrf-token";
export const ERROR_CODE_INTERNAL_SERVER: string =
	"server/internal-server-error";
